import { Component, EventEmitter, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-carrier-dialog',
  templateUrl: './delete-carrier.dialog.html',
  styleUrls: ['./delete-carrier.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class DeleteCarrierDialog implements OnInit {
  @Output() onDelete = new EventEmitter();
  carrierName: string;

  constructor(
    public dialogRef: MatDialogRef<DeleteCarrierDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.carrierName = this.data.carrierName;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onDeleteClicked(): void {
    this.onDelete.emit();
    this.dialogRef.close();
  }
}
